import { Factory } from 'rosie';

Factory.define('ConversationWorkflowConfig').attr('name', 'CONVERSATION_WORKFLOW_CONFIG');

Factory.define('ConversationWorkflowConfigWithDefaults')
  .extend('ConversationWorkflowConfig')
  .attr('reopenWindow', 9000000000000)
  .attr('requireTopics', true);



// WEBPACK FOOTER //
// ./factories/conversation_workflow_config_factory.js